export default __webpack_public_path__ + "6842930.png";